module.exports = __webpack_public_path__ + "static/img/ship.2cb8570.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/index/ship.png
// module id = IfA4
// module chunks = 0